import { handleBonusNotificationInfo } from '../common/handleBonusNotificationInfo';

export const bonusNotification = async ({ data: actionInfo }, { lang, syncClose, dispatch }) =>
    handleBonusNotificationInfo({ actionInfo, isConfirmation: true }, { lang, syncClose, dispatch });
